import React from 'react'
import View from './view'

const Contact = ({ ...props }) => {
  return <View {...props} />
}

export default Contact
